




































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IBlock } from "@/interfaces";

@Component
export default class TableBlocksMobile extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public blocks: IBlock[] | null;
  @Prop({ required: false, default: false }) public hideGeneratedBy: boolean;
}
